export default __webpack_public_path__ + "static/media/KalliFinal.f3ea58ea.gif";